<template>
  <div class="order">
    <van-nav-bar title="考试成绩" left-arrow @click-left="$router.go(-1)" />
   

    <div v-if="!data">
      <van-empty description="暂无考试成绩信息" />
    </div>
    <div v-else>
        <van-cell-group  :title="data.examination_info.name">
          <van-cell title="语文" :value="data.chinese" />
          <van-cell title="数学" :value="data.maths" />
          <van-cell title="英语" :value="data.english" />
          <van-cell title="物理" :value="data.physics" />
          <van-cell title="化学" :value="data.chemistry" />
          <van-cell title="生物" :value="data.biology" />
          <van-cell title="政治" :value="data.politics" />
          <van-cell title="历史" :value="data.history" />
          <van-cell title="地理" :value="data.geography" />
          <van-cell title="计算机" :value="data.computer" />
          <van-cell title="总分" :value="data.total" />
        </van-cell-group>
        <van-cell-group title="综合排名">
          
          <van-cell title="班级排名" :value="data.class_ranking" />
          <van-cell title="年级排名" :value="data.grade_ranking" />
          <van-cell title="评语" :value="data.comment" />
        </van-cell-group> 
     
    </div>
  </div>
</template>

<script>

import { getStudentScore } from '@/api/home'



export default {
  name: 'QueryScore',
  components: {
  },
  data () {
    return {

      data: '',
      childrenInfo:{}

    }
  },
  mounted () {
      this.childrenInfo=JSON.parse(localStorage.getItem('childrenInfo'))

      this.getScoreByStudentNo()
  },
  methods: {
    async getScoreByStudentNo () {
      let params={
        studentNo:this.childrenInfo.student_no
      }
      const response = await getStudentScore(params)

      console.log('response', response);
      this.data = response.data
    },


  },
  watch: {
    
  }
}
</script>

<style lang="less" scoped>
.order {
  background-color: #fafafa;
}
.van-tabs {
  position: sticky;
  top: 0;
}
.search-btn{
  background-color: #04be02;
  color: #fff;
  width: 90%;
  margin: 0 auto;
  font-size: 16px;
  border-radius: 10px;

}
.access_box{
  margin-top: 5px;
  margin-bottom: 5px;
  border-top: 1px solid #ddd;

}
</style>
